import { connect } from 'react-redux';

import { EVENTS } from 'legacy/appstore/events';
import { SECTION_ID_COMPS } from 'legacy/appstore/constants';

import { changeGlossarySelected } from 'actions/support';
import { downloadReportSection } from 'actions/download-report';
import { analyticsEvent } from 'actions/analytics';

import {
  getCompsSelectedOrSuggestedIdsOrderedBySimilarity,
  getCompsSelectedOrSuggestedMessage,
  getCompsSelectionButtonView,
  getCompsSelectionButtonHide,
  getCompsSelectionButtonLabel
} from 'selectors/comps';
import {
  getIsReportEditable,
  getIsExcelDownloadAllowed
} from 'selectors/report-permissions';
import {
  getReportStatusCompsIsLoadedInitial,
  getReportStatusCompsIsLoaded,
  getReportStatusCompsIsError
} from 'selectors/report-status';

import loadWhenReady from 'legacy/hocs/loadWhenReady';

import CompsSummarySection from 'legacy/components/CompsSummarySection';

const mapStateToProps = (state, ownProps) => {
  return {
    title: 'Sold & Active Comparables',
    buttonLabel: getCompsSelectionButtonLabel(state),
    isLoaded: getReportStatusCompsIsLoaded(state),
    isLoadedInitial: getReportStatusCompsIsLoadedInitial(state),
    isError: getReportStatusCompsIsError(state),
    isReportEditable: getIsReportEditable(state),
    message: getCompsSelectedOrSuggestedMessage(state),
    buttonView: getCompsSelectionButtonView(state),
    hideCTA: getCompsSelectionButtonHide(state),
    isExcelDownloadAllowed: getIsExcelDownloadAllowed(state),
    dataHcNames: {
      header: 'sold-comps-header-text',
      button: 'select-comps-button',
      section: 'comps-section',
      gallery: 'sold-comps-gallery'
    },
    addressIds: getCompsSelectedOrSuggestedIdsOrderedBySimilarity(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickInfo: () => dispatch(changeGlossarySelected(['COMPARABLE_VALUE'])),
    onClickDownload: () => dispatch(downloadReportSection('comps')),
    onClickChooseComps: () =>
      dispatch(analyticsEvent(EVENTS.COMPS_SELECT_CLICK))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(loadWhenReady(CompsSummarySection, SECTION_ID_COMPS));
